import { object, string } from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { User, UserProp, UserResponse } from "../../model/User";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { Fetch } from "../../lib/https";
import { buildEndpoint } from "../../util/buildEndpoint";
import { useState } from "react";
import { useAuth } from "../../context/auth";
import { handelServerMessageMap } from "../../util/handelServerMessageMap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { HttpMessage } from "../../static/AppError";

export const useHandelUser = () => {
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const intl = useIntl();
  const messages = handelServerMessageMap(intl);
  const schema = object().shape({
    email: string().required().email(),
    password: string().required(""),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  function ToGetMe() {
    const result = useQuery({
      queryKey: ["user"],
      queryFn: async () => await getMe(),
      retry: 0,
      refetchOnWindowFocus: false,
    });
    return result;
  }

  const getMe = async (): Promise<User> => {
    const response = await Fetch({
      endpoint: "/user",
      requiredAuth: true,
    });
    return response;
  };

  function ToGetUser(id?: number) {
    const result = useQuery({
      queryKey: ["userProfile", id],
      queryFn: async () => await getUser(Number(id)),
      enabled: !!id,
      retry: false,
      refetchOnWindowFocus: false,
    });
    return result;
  }

  const getUser = async (id: number): Promise<User> => {
    const response = await Fetch({
      endpoint: `/user/${id}`,
      requiredAuth: true,
    });
    return response?.data;
  };

  function ToGetUsers(props: UserProp) {
    const result = useQuery({
      queryKey: ["users", props],
      queryFn: async () => await getUsers(props),
      refetchOnWindowFocus: false,
      retry: false,
      placeholderData: keepPreviousData,
      staleTime: Infinity,
    });
    return result;
  }

  const getUsers = async (userProp: UserProp): Promise<UserResponse> => {
    const response = await Fetch({
      endpoint: buildEndpoint("users", userProp),
      requiredAuth: true,
    });
    return response?.data;
  };

  const deleteMutation = useMutation({
    mutationFn: async () => {
      const response = await Fetch({
        method: "DELETE",
        endpoint: `/delete-profile`,
        requiredAuth: true,
      });
      return response;
    },
    onSuccess: () => {
      setLoading(false);
      localStorage.setItem("redirect-path", "/dashboard");
      auth.logout();
    },
    onError: () => {
      setLoading(false);
      toast.error(messages[HttpMessage.INTERNAL_SERVER_ERROR]);
    },
  });

  const onDeleteProfile = () => {
    setLoading(true);
    deleteMutation.mutate();
  };

  const onSubmit = async (data: any) => {
    // mutation.mutate(data);
  };

  return {
    ToGetMe,
    ToGetUser,
    ToGetUsers,
    errors,
    register,
    handleSubmit,
    reset,
    onSubmit,
    loading,
    setLoading,
    onDeleteProfile,
  };
};
